const IDV_REDIRECT_MAP = {
  KYC_REQUIRED: '/kyc',
  NDA_REQUIRED: '/nda',
  FACE_AUTH_REQUIRED: '/face-auth',
};

export default function ({ $axios, app, redirect }) {
  $axios.onError((error) => {
    const code = parseInt(error.response?.status);

    if (code === 403) {
      const errorCode = error.response?.data?.error;
      if (errorCode && IDV_REDIRECT_MAP[errorCode]) {
        redirect(IDV_REDIRECT_MAP[errorCode]);
        return Promise.resolve(false);
      }
    }

    if (code === 401) {
      if (
        error.request &&
        !error.request.responseURL.endsWith('user.php') &&
        !error.request.responseURL.endsWith('tfa.php')
      ) {
        if (app.$auth.loggedIn) {
          app.$auth
            .logout()
            .then((res) => {})
            .catch(() => {});
        }
        return Promise.resolve(false);
      }
    }
  });
}
